var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToilet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 26.5832H20.5417V23.5623C23.4538 21.5928 25.375 18.2698 25.375 14.4998V4.83317C25.375 4.19223 25.1204 3.57754 24.6672 3.12433C24.214 2.67112 23.5993 2.4165 22.9583 2.4165H18.125C17.4841 2.4165 16.8694 2.67112 16.4162 3.12433C15.9629 3.57754 15.7083 4.19223 15.7083 4.83317V14.4998H3.625C3.625 18.2336 6.04167 21.7498 10.875 23.5623V26.5832ZM6.39208 16.9165H22.6079C22.2685 18.0538 21.6941 19.1071 20.9219 20.0084C20.1496 20.9097 19.1968 21.6388 18.125 22.1486V24.1665H13.2917V22.1486C10.875 21.7498 7.08083 19.2244 6.39208 16.9165ZM18.125 4.83317H22.9583V14.4998H18.125V4.83317ZM19.3333 6.0415V9.6665H21.75V6.0415H19.3333Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToilet);
export default __webpack_public_path__ + "static/media/toilet.a628e7edc9f941387da9c6689907f7aa.svg";
export { ForwardRef as ReactComponent };